// Date and Time format constants
export const twelveHoursWithAMPM = "hh:mm aa";
export const dayMonthDate = "EEE, MMM d";
export const AM = "AM";
export const PM = "PM";
export const dropdownZIndex = "9999";
export const dateTimePickerZIndex = "1001";
export const fieldsBorderRadius = "6px";

// Export modal
export const Excel = "Excel";
export const GeoJSON = "GeoJSON";
export const PDF = "PDF";
export const JSON = "JSON";

// These values are obtained using filter generator for images for the color #4692A9
export const imageFilter =
    "invert(48%) sepia(78%) saturate(283%) hue-rotate(147deg) brightness(92%) contrast(93%)";
